export default "__VITE_ASSET__gNVEB3I6__"